// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__26G8m","footer":"ModalInfo_footer__1Bo5y"};